module.exports = __webpack_public_path__ + "static/bunnytoy-26978bf247bb98ac263ee4d8278bda16.jpeg";